import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-grid-element',
  templateUrl: './grid-element.component.html',
  styleUrls: ['./grid-element.component.scss']
})
export class GridElementComponent implements OnInit {

  @Input()
  isLoading: boolean;

  @Input()
  title: string;

  @Input()
  subtitleHTML: string;

  @Input()
  previewImage: string;

  @Input()
  previewOverlay: boolean;

  @Input()
  bottomIcons: string[];

  @Input()
  bottomIconText: string;

  @Input()
  canClickBottomIcon: boolean;

  @Input()
  canEdit: boolean;

  @Input()
  canRemove: boolean;

  @Input()
  selectable: boolean;

  @Input()
  selected: boolean;

  @Input()
  disabled: boolean;

  @Output()
  onBottomIconClicked = new EventEmitter();

  @Output()
  onEdit = new EventEmitter();

  @Output()
  onRemove = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  edit(event) {
    event.stopPropagation();
    this.onEdit.next();
  }

  remove(event) {
    event.stopPropagation();
    this.onRemove.next();
  }

  bottomIconClick(event) {
    if (this.canClickBottomIcon) {
      event.stopPropagation();
      this.onBottomIconClicked.emit();
    }
  }

  getImagePreview() {
    return {
      backgroundImage: 'url(' + this.previewImage + ')',
      backgroundPosition: this.previewOverlay ? 'bottom -55px right -50px' : '',
      backgroundSize: this.previewOverlay ? '245px' : '',
      backgroundBlendMode: this.previewOverlay ? 'overlay' : '',
    };
  }

}
